/* batida-konto-rok.js: "Twój rok z Batidą" in Moje konto (sections/batida-konto-rok.liquid; phase 2, 29.09).
   From the customer's own paid orders of this calendar year (printed by the section; fees, candles, the letter and
   T-shirts left out of the products): number of orders, the favourite product, the favourite day (service date, else
   the order date), the boutique picked up from most often, occasions from "Przypomnij mi za rok" reminders (Batida
   Connect). Year-round, January to today; shown from the "Minimum" paid orders (default 2).
   "Pobierz grafikę na Instagram Story": a 1080x1920 PNG drawn in the browser (canvas, brand fonts and colours) -
   first name only, no prices, no addresses; phones get the share sheet when they support sharing files.
   ?kontodemo=1: sample figures. Registers with the panel (assets/batida-konto.js, window.BatidaKontoQ). */
(function () {
  'use strict';
  var el = document.querySelector('[data-v7k-feat="rok"]');
  if (!el) return;
  var F; try { F = JSON.parse(el.textContent); } catch (e) { return; }
  var T = F.t || {};
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tx(k, vars) { return esc(T[k] || '').replace(/\{(\w+)\}/g, function (m, n) { return vars && vars[n] != null ? vars[n] : ''; }); }
  function raw(k, vars) { return String(T[k] || '').replace(/\{(\w+)\}/g, function (m, n) { return vars && vars[n] != null ? vars[n] : ''; }); }
  var CTX = null, wired = false, STATS = null;

  function form(n, lang) {
    var f = String(T.orders_forms || '').split('|');
    if (lang !== 'pl') return n === 1 ? f[0] : (f[1] || f[0]);
    if (n === 1) return f[0];
    var d = n % 10, h = n % 100;
    return d >= 2 && d <= 4 && (h < 12 || h > 14) ? (f[1] || f[0]) : (f[2] || f[1] || f[0]);
  }
  function top(counts) { var k = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0]; return k ? [k, counts[k]] : null; }

  function stats(ctx) {
    var h = ctx.h, days = String(T.days || '').split(',');
    if (ctx.DEMO) {
      return { n: 7, product: ['Miłości', 9], day: days[5] || '', shop: 'Królewska', occ: ['urodziny'], year: F.year };
    }
    var O = Array.isArray(F.orders) ? F.orders : [];
    if (O.length < (F.min || 2)) return null;
    var prod = {}, dayc = {}, shops = {};
    O.forEach(function (o) {
      (o.items || []).forEach(function (it) { prod[it.t] = (prod[it.t] || 0) + (Number(it.q) || 1); });
      var d = h.normYmd(o.d) || h.normYmd(o.c); if (d) { var w = h.dow(d); dayc[w] = (dayc[w] || 0) + 1; }
      if (o.loc) shops[o.loc] = (shops[o.loc] || 0) + 1;
    });
    var p = top(prod), dd = top(dayc), sh = top(shops);
    var occ = [];
    ((ctx.connect && ctx.connect.dates) || []).forEach(function (x) { var l = String(x.label || '').trim(); if (x.source === 'cart' && l && occ.indexOf(l) < 0 && occ.length < 3) occ.push(l); });
    return { n: O.length, product: p, day: dd ? days[+dd[0]] || '' : '', shop: sh ? h.shortName(sh[0]) : '', occ: occ, year: F.year };
  }

  function render(ctx) {
    CTX = ctx;
    var slot = ctx.slot('start', 'rok');
    if (!slot) return;
    if (!(F.on || ctx.DEMO)) { slot.innerHTML = ''; return; }
    var S = STATS = stats(ctx);
    if (!S) { slot.innerHTML = ''; return; }
    var tiles = [['<b>' + esc(S.n) + '</b>', esc(form(S.n, ctx.LANG)) + ' ' + tx('orders_sub')]];
    if (S.product) tiles.push(['<b>' + esc(S.product[0]) + '</b>', tx('top_sub', { n: esc(S.product[1]) })]);
    if (S.day) tiles.push(['<b>' + esc(S.day) + '</b>', tx('day_sub')]);
    if (S.shop) tiles.push(['<b>' + esc(S.shop) + '</b>', tx('shop_sub')]);
    var html = '<div class="v7k-yr__h"><div><h2 class="v7k-h2 v7k-yr__t">' + tx('title') + ' <i>' + tx('title_i') + '</i></h2><p class="v7k-sub">' + tx('sub', { rok: esc(S.year) }) + '</p></div>' +
      '<button type="button" class="v7k-btn" data-v7k-story>' + tx('btn') + '</button></div>' +
      '<div class="v7k-yr__g">' + tiles.map(function (t) { return '<div>' + t[0] + '<span>' + t[1] + '</span></div>'; }).join('') + '</div>';
    if (S.occ.length && T.occ) html += '<p class="v7k-small v7k-yr__occ">' + tx('occ', { lista: esc(S.occ.join(', ')) }) + '</p>';
    slot.innerHTML = ctx.h.box('s12 v7k-yr', html);
    if (!wired) { wired = true; ctx.app.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-v7k-story]'); if (b) story(b); }); }
  }

  /* ---------- the Instagram Story image ---------- */
  var INK = '#1A1512', RASP = '#B84A52', BG = '#FAF9F7', BLUSH = '#FBE1DD', MUTED = '#6B625B';
  var DISPLAY = "'Batida Display', 'Archivo', 'Arial Narrow', sans-serif", SERIF = "'Instrument Serif', Georgia, serif", BODY = "Outfit, system-ui, sans-serif";
  function fit(g, text, font, size, maxW, minSize) {
    var s = size; g.font = font.replace('{s}', s);
    while (g.measureText(text).width > maxW && s > minSize) { s -= 4; g.font = font.replace('{s}', s); }
    return s;
  }
  function wrap(g, text, x, y, maxW, lh, maxLines) {
    var words = String(text).split(/\s+/), line = '', lines = [];
    words.forEach(function (w) { var t = line ? line + ' ' + w : w; if (g.measureText(t).width > maxW && line) { lines.push(line); line = w; } else line = t; });
    if (line) lines.push(line);
    lines.slice(0, maxLines).forEach(function (l, i) { g.fillText(l, x, y + i * lh); });
  }
  function rrect(g, x, y, w, h, r) { g.beginPath(); g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r); g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath(); }
  /* 30.09 (Aleksandra): the REAL logo - the header's own inline SVG (snippets/batida-v7-logo.liquid), drawn as an image at
     its final size so it stays crisp; the text wordmark is only the fallback when the SVG isn't on the page */
  function logoImage() {
    var svg = document.querySelector('svg.v7-logo') || document.querySelector('svg.v7-footer__logo-svg');
    if (!svg) return Promise.resolve(null);
    var vb = String(svg.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number);
    var ratio = vb.length === 4 && vb[3] ? vb[2] / vb[3] : 2.887;
    var c = svg.cloneNode(true), w = 1040;
    c.setAttribute('xmlns', 'http://www.w3.org/2000/svg'); c.setAttribute('width', String(w)); c.setAttribute('height', String(Math.round(w / ratio)));
    c.removeAttribute('class'); c.removeAttribute('role'); c.removeAttribute('aria-label');
    var str = new XMLSerializer().serializeToString(c).replace(/currentColor/g, INK);
    return new Promise(function (res) {
      var img = new Image();
      img.onload = function () { res({ img: img, ratio: ratio }); };
      img.onerror = function () { res(null); };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(str);
    });
  }
  function draw(logo) {
    var S = STATS, W = 1080, H = 1920, c = document.createElement('canvas'); c.width = W; c.height = H;
    var g = c.getContext('2d');
    g.fillStyle = BG; g.fillRect(0, 0, W, H);
    g.fillStyle = BLUSH; rrect(g, 60, 60, W - 120, 680, 48); g.fill();
    g.textBaseline = 'alphabetic'; g.fillStyle = INK;
    fit(g, raw('story_title'), '600 {s}px ' + DISPLAY, 170, W - 220, 90); g.fillText(raw('story_title'), 110, 300);
    g.fillStyle = RASP; fit(g, raw('story_title_i'), 'italic 400 {s}px ' + SERIF, 170, W - 220, 90); g.fillText(raw('story_title_i'), 110, 460);
    g.fillStyle = INK; g.font = '500 54px ' + BODY;
    var who = (CTX && CTX.D && CTX.D.first ? CTX.D.first + ' · ' : '') + S.year;
    g.fillText(who, 110, 600);
    var tiles = [[String(S.n), form(S.n, CTX.LANG) + ' ' + raw('orders_sub')]];
    if (S.product) tiles.push([S.product[0], raw('top_sub', { n: S.product[1] })]);
    if (S.day) tiles.push([S.day, raw('day_sub')]);
    if (S.shop) tiles.push([S.shop, raw('shop_sub')]);
    var tw = (W - 120 - 40) / 2, th = 340;
    tiles.slice(0, 4).forEach(function (t, i) {
      var x = 60 + (i % 2) * (tw + 40), y = 800 + Math.floor(i / 2) * (th + 40);
      g.fillStyle = '#FFFFFF'; rrect(g, x, y, tw, th, 40); g.fill();
      g.fillStyle = RASP; fit(g, t[0], '600 {s}px ' + DISPLAY, 120, tw - 80, 48); g.fillText(t[0], x + 40, y + 150);
      g.fillStyle = MUTED; g.font = '400 38px ' + BODY; wrap(g, t[1], x + 40, y + 222, tw - 80, 48, 2);
    });
    g.textAlign = 'center';
    if (logo) {
      var lw = 520, lh = Math.round(lw / logo.ratio);
      g.drawImage(logo.img, Math.round((W - lw) / 2), H - 150 - lh, lw, lh);
    } else {
      g.fillStyle = INK; g.font = '600 120px ' + DISPLAY; g.fillText('batida', W / 2, H - 170);
    }
    g.font = '500 44px ' + BODY; g.fillStyle = MUTED; g.fillText(raw('story_tag'), W / 2, H - 80);
    g.textAlign = 'left';
    return c;
  }
  function story(btn) {
    if (!STATS) return;
    btn.disabled = true;
    var fonts = document.fonts && document.fonts.load ? Promise.all([
      document.fonts.load("600 120px 'Batida Display'"), document.fonts.load("italic 120px 'Instrument Serif'"), document.fonts.load('500 44px Outfit')
    ]).catch(function () {}) : Promise.resolve();
    fonts.then(logoImage).then(function (logo) {
      var c = draw(logo), name = 'batida-' + STATS.year + '.png';
      try { c.toBlob(function () {}, 'image/png'); } catch (e) { c = draw(null); }        /* a browser that won't export an SVG-drawn canvas: text logo */
      c.toBlob(function (blob) {
        btn.disabled = false;
        if (!blob) return;
        var file = null; try { file = new File([blob], name, { type: 'image/png' }); } catch (e) {}
        if (file && navigator.canShare && navigator.canShare({ files: [file] }) && navigator.share) {
          navigator.share({ files: [file] }).catch(function () {});
          return;
        }
        var url = URL.createObjectURL(blob), a = document.createElement('a');
        a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
      }, 'image/png');
    });
  }
  /* for the team's checks: window.__v7kStory() returns the image as a data URL */
  window.__v7kStory = function () {
    if (!STATS) return Promise.resolve(null);
    return logoImage().then(function (logo) { try { return draw(logo).toDataURL('image/png'); } catch (e) { return draw(null).toDataURL('image/png'); } });
  };

  (window.BatidaKontoQ = window.BatidaKontoQ || []).push({ id: 'rok', render: render });
})();
